module.exports = __webpack_public_path__ + "static/media/filter.26dbd368.svg";